import { HttpError, isTransportFailure } from '@/shared/infra/http'

export type ReportSeverity = 'error' | 'warning'

const EXPECTED_CLIENT_STATUSES = [401, 403, 404, 409, 428]
const CONTRACT_STATUSES = [400, 422]
const BODYLESS_METHODS = ['GET', 'HEAD', 'DELETE']

export function classifyErrorSeverity(err: unknown): ReportSeverity {
  if (isTransportFailure(err)) {
    return 'warning'
  }

  if (!(err instanceof HttpError)) {
    return 'error'
  }

  if (err.status >= 500) {
    return 'error'
  }

  if (EXPECTED_CLIENT_STATUSES.includes(err.status)) {
    return 'warning'
  }

  if (CONTRACT_STATUSES.includes(err.status)) {
    const method = err.method?.toUpperCase()
    const isBodyless = method === undefined || BODYLESS_METHODS.includes(method)
    return isBodyless ? 'error' : 'warning'
  }

  if (err.status >= 400) {
    return 'warning'
  }

  return 'error'
}
